import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { SubscriptionStore } from '@core/store/subscription.store';

export const platformInitGuard: CanMatchFn = () => {
  inject(SubscriptionStore).ensureCurrentLoaded();
  return true;
};
